module.exports = __webpack_public_path__ + "img/jcb.f0ca413a.png";